import styles from './SaveJob.less';

import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';

import { ScreenReaderOnly } from 'seek-style-guide/react';
import SignInRegisterLink from 'SignInRegisterLink/SignInRegisterLink';
import { StarIcon, TickIcon } from 'seek-style-guide/react';
import { saveJob, removeSavedJob } from 'store/savedJobs/savedJobs';

const mapStateToProps = ({ user, savedJobs }) => ({
  savedJobs: savedJobs.jobs,
  authenticated: user.authenticated
});

const mapDispatchToProps = dispatch => ({
  saveJobHandler: jobId => dispatch(saveJob(jobId)),
  removeSavedJobHandler: jobId => dispatch(removeSavedJob(jobId))
});

@connect(mapStateToProps, mapDispatchToProps)
class SaveJob extends Component {

  static propTypes = {
    id: PropTypes.number.isRequired,
    savedJobs: PropTypes.object.isRequired,
    saveJobHandler: PropTypes.func.isRequired,
    removeSavedJobHandler: PropTypes.func.isRequired,
    authenticated: PropTypes.bool.isRequired
  };

  renderApplied() {
    return (
      <div className={styles.root} data-automation="applied-job">
        <TickIcon
          className={styles.icon}
          svgClassName={`${styles.iconSvg} ${styles.iconSvg_isApplied}`}
        />
        <ScreenReaderOnly>You have applied for this job</ScreenReaderOnly>
        <span aria-hidden="true"> Applied</span>
      </div>
    );
  }

  renderSave() {
    const { id, savedJobs, saveJobHandler, removeSavedJobHandler } = this.props;
    const saved = (savedJobs[id] === 'saved');
    const buttonTitle = saved ? 'Remove from your saved jobs' : 'Save this job';
    const clickHandler = saved ? removeSavedJobHandler : saveJobHandler;
    const rootClassName = classnames(styles.root, styles.root_isButton);
    const svgClassName = classnames({
      [styles.iconSvg]: true,
      [styles.iconSvg_isSaved]: saved
    });

    /* eslint-disable react/jsx-no-bind */
    return (
      <span>
        {
          saved &&
            <ScreenReaderOnly>This is a saved job.</ScreenReaderOnly>
        }
        <button
          className={rootClassName}
          onClick={() => clickHandler(id)}
          title={buttonTitle}
          aria-label={buttonTitle}
          data-automation={saved ? 'remove-saved-job' : 'save-job'}>
          <StarIcon
            filled={saved}
            className={styles.icon}
            svgClassName={svgClassName}
          />
          {saved ? 'Saved' : 'Save'}
        </button>
      </span>
    );
    /* eslint-enable react/jsx-no-bind */
  }

  renderSignedIn() {
    const { id, savedJobs } = this.props;
    const applied = savedJobs[id] === 'applied';

    return applied ? this.renderApplied() : this.renderSave();
  }

  renderSignedOut() {
    const { id } = this.props;
    const className = classnames(styles.root, styles.root_isLink);

    return (
      <SignInRegisterLink
        mode="signin"
        params={{ savejob: id }}
        className={className}
        title="Sign in to save this job"
        data-automation="signed-out-save-job">
        <StarIcon
          className={styles.icon}
          svgClassName={styles.iconSvg}
        />
        Save
      </SignInRegisterLink>
    );
  }

  render() {
    const { authenticated } = this.props;

    return authenticated ?
      this.renderSignedIn() :
      this.renderSignedOut();
  }
}

export default SaveJob;



/** WEBPACK FOOTER **
 ** ./app/components/SearchResultPage/components/SearchResultList/components/JobItem/components/SaveJob/SaveJob.js
 **/